import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { routeTo } from "router";
import { useAppDispatch, useAppSelector } from "store";
import { sandboxActionCompleted, sandboxActionInvoked, selectCurrentUser } from "store/features";
import { CodeShareMetadata } from "types";
import { MigrationDialog } from "./MigrationDialog";
import { TrackedSandboxEvent, useTrackSandboxEvent } from "services/telemetry-service/telemetry";

interface MigrationActionHandlerProps {
  userId?: string;
  sandboxId?: string;
}

export const MigrationActionHandler = ({ userId, sandboxId }: MigrationActionHandlerProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectCurrentUser);
  const sandboxUser = useAppSelector((state) => state.auth.sandboxUser);
  const trackEvent = useTrackSandboxEvent<TrackedSandboxEvent>("Sandbox migrated");

  const onClose = () => {
    dispatch(sandboxActionCompleted());
  }

  const onConfirm = (sandbox: CodeShareMetadata) => {
    onClose();
    navigate(routeTo.sandbox({ userName: sandbox.username, sandboxName: sandbox.name, file: "migration.md" }), { replace: true });
    trackEvent({ SandboxName: sandbox.name, SandboxUser: sandbox.username, SandboxUserId: sandbox.userId, SandboxId: sandbox.id });
  }

  useEffect(() => {
    if (!sandboxUser) {
      dispatch(sandboxActionInvoked({ type: "set-username", args: { actionResumeType: "create" } }));
    }
  }, [dispatch, sandboxUser]);

  if (!user) {
    dispatch(sandboxActionInvoked({ type: "signin-prompt" }));
    return null;
  }

  if (!sandboxUser) {
    dispatch(sandboxActionInvoked({ type: "set-username", args: { actionResumeType: "create" } }));
    return null;
  }

  if (!userId || !sandboxId) {
    console.error("userId and sandboxId must be provided to Fork action")
    return null;;
  }

  return (
    <MigrationDialog onConfirm={onConfirm} onClose={onClose} userId={userId} sandboxId={sandboxId} sandboxUser={sandboxUser} />
  )
};
